import PropTypes from "prop-types";

export default function ContentScrollable(props) {
	const { children, scrollTo } = props;

	if (scrollTo) {
		try {
			const section = document.getElementById(`${scrollTo}`);
			if (section) {
				section.scrollIntoView({ behavior: "smooth", block: "start" });
			}
		} catch (error) {
			console.log(error);
		}
	}

	return <>{children}</>;
}
ContentScrollable.propTypes = {
	children: PropTypes.node,
	scrollTo: PropTypes.string,
};
